import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { CategoriesStoreService } from 'src/app/core/store/services/categories-store.service';

@Component({
  selector: 'craft-category-label',
  templateUrl: './craft-category-label.component.html',
  styleUrls: ['./craft-category-label.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class CraftCategoryLabelComponent {
  @Input() public selectedId: string | null | undefined;

  constructor(public cs: CategoriesStoreService) {}
}
